import React__default, { useMemo } from 'react';
import classNames from 'classnames';
import { useAnalyticsEvents } from '@invitae/nucleobase-analytics';
import { useCountryLocationPrefix } from '@invitae/nucleobase-engine-contentful';
import styles from './NavLink.module.esm.js';

var NavLink = function (_a) {
    var _b;
    var id = _a.id, onClick = _a.onClick, selected = _a.selected, text = _a.text, url = _a.url, dataCy = _a.dataCy, analyticsEvents = _a.analyticsEvents;
    var addCountryCodePrefix = useCountryLocationPrefix().addCountryCodePrefix;
    var handleClick = useAnalyticsEvents({ analyticsEvents: analyticsEvents, defaultOnClick: onClick }).onClick;
    var className = classNames(styles.footerLink, (_b = {},
        _b[styles.selected] = id && selected && id === selected,
        _b));
    var generatedUrl = useMemo(function () { return (url.startsWith('http') ? url : addCountryCodePrefix(url)); }, [url, addCountryCodePrefix]);
    return (React__default.createElement("li", null,
        React__default.createElement("a", { className: className, "data-cy": dataCy, href: generatedUrl, onClick: handleClick }, text)));
};

export { NavLink as default };
//# sourceMappingURL=NavLink.esm.js.map
